import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { Store } from '@ngrx/store';

import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';
import type { Candidate } from '@core/candidate-types';
import { AnonymousCandidateEmptyStateComponent } from '@core/candidate-ui';
import { TranslatePipe } from '@core/i18n-legacy';

import { CandidateDataVisibilityAnalyticsDirective } from './candidate-data-visibility-analytics.directive';
import { CandidateDataVisibilityService } from '../services/candidate-data-visibility.service';

@Component({
  selector: 'rt-anonymous-candidate-empty-state-wrapper',
  template: `
    <rt-anonymous-candidate-empty-state
      rtCandidateDataVisibilityAnalytics
      [candidate]="candidate()"
      [skipRevealConfirmation]="candidateVisibilityService.shouldSkipRevealConfirmation()"
      [message]="'app.mailbox.message_hidden_empty_state' | translate"
      [style]="{ 'max-width': maxWidthPx() }"
      [canReveal]="canReveal()"
      (saveSkipRevealConfirmation)="candidateVisibilityService.saveDontAskForConfirmationAgain()"
      (toggleDataVisibility)="
        candidateVisibilityService.toggleDataVisibility(candidate().id, $event)
      "
    />
  `,
  styles: `
    :host {
      display: flex;
      justify-content: center;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AnonymousCandidateEmptyStateComponent,
    TranslatePipe,
    CandidateDataVisibilityAnalyticsDirective,
  ],
})
export class AnonymousCandidateEmptyStateWrapperComponent {
  protected readonly canReveal = inject(Store).selectSignal(
    AbilitiesSelectors.hasOne(Ability.RevealAnonymousCandidates),
  );

  protected readonly candidateVisibilityService = inject(CandidateDataVisibilityService);

  public readonly candidate = input.required<Candidate>();

  public readonly maxWidthPx = input<string, number | string>('450px', {
    transform: (value: number | string) => `${+value}px`,
  });
}
